import { Component, OnInit } from "@angular/core";

import { ApiService } from "src/app/api.service";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-add-raw-config",
	templateUrl: "./add-raw-config.component.html",
	styleUrls: ["./add-raw-config.component.scss"]
})
export class AddRawConfigComponent implements OnInit {
	public organizations: APIResults.Organization[];
	public selectedOrganization: APIResults.Organization;
	public newConfig: string;

	constructor(public api: ApiService) { }

	ngOnInit() {
		this.UpdateOrganizations();
	}
	async UpdateOrganizations() {
		const organizations = await this.api.GetOrganizations();
		this.organizations = organizations;
	}

	async UploadConfig() {
		try {
			await this.api.AddConfig(this.selectedOrganization.organization_id, this.newConfig);
		} catch (err) {
			if (err.error && err.error.message && err.error.message.startsWith("ER_DUP_ENTRY")) {
				throw new Error("A configuration with that name already exists for that organization.");
			}
			throw err;
		}
	}
}
